/**
 * frontend/src/modules/search/hooks/useSearch.ts
 * PHASE 3.2 F2 — Hook TanStack Query pour la recherche globale.
 *
 * Debounce 300ms — ne lance la requête que si q ≥ 1 caractère.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchSearch } from '../api'
import type { SearchResponse } from '../types'

export function useSearch(q: string) {
  const trimmed = q.trim()

  return useQuery<SearchResponse>({
    queryKey: ['search', trimmed],
    queryFn:  () => fetchSearch(trimmed),
    enabled:  trimmed.length >= 1,
    staleTime: 10 * 1000,  // 10s — résultats frais
    retry: 0,
    placeholderData: (prev) => prev,
  })
}
